import React from 'react';

/**
 * @param {number} colSpan - The number of columns in your table (to center the text)
 * @param {string} message - The message to display
 */
export function EmptyTableMessage({ colSpan, message = "No Data Found" }) {
  return (
    <tr>
      <td colSpan={colSpan} className="py-5">
        <div className="d-flex flex-column align-items-center justify-content-center w-100">
          {/* Optional: Add a subtle icon for better UI */}
          <i className="ph ph-folder-open text-muted mb-2" style={{ fontSize: '3rem', opacity: 0.5 }} />
          <h6 className="text-center w-100 text-muted mb-0">
            {message}
          </h6>
        </div>
      </td>
    </tr>
  );
}